import { render } from "./pop-up.vue?vue&type=template&id=6206f98a&scoped=true"
import script from "./pop-up.vue?vue&type=script&lang=js"
export * from "./pop-up.vue?vue&type=script&lang=js"

import "./pop-up.vue?vue&type=style&index=0&id=6206f98a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6206f98a"

export default script